// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"fb3809d4","488":"270b27b8","732":"93889f0b","977":"b7ed9f43"}[chunkId] + ".chunk.js");